import { render, staticRenderFns } from "./detailBaseInfo.vue?vue&type=template&id=345ad440&scoped=true"
import script from "./detailBaseInfo.vue?vue&type=script&lang=js"
export * from "./detailBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./detailBaseInfo.vue?vue&type=style&index=0&id=345ad440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ad440",
  null
  
)

export default component.exports